import { LobbyManifest } from '../app/manifest/lobby.manifest';
/**
 * Created by karthikeyan.k on 07-03-2018.
 */
export class SpriteController {
  public static getImageFromSprite(
    spriteContainer,
    image,
    imageJson,
    imageName,
    basePath = ''
  ): Promise<any> {
    // console.log(imageJson);
    // console.log(imageJson.frames);
    if (imageJson == undefined) {
      console.log('imageName==============================================');
      console.log(imageName);
    }

    // //console.log(imageJson.frames[imageName.toLowerCase()]);
    return new Promise((resolve, reject) => {
      if (
        imageJson.frames == null ||
        imageJson.frames === undefined ||
        imageJson.frames[imageName] == null ||
        imageJson.frames[imageName] === undefined
      ) {
        // console.log('NULLL', imageName);
        return reject(new Error('error with sprite name-' + imageName));
      } else {
        if (spriteContainer[imageName]) {
          resolve(spriteContainer[imageName]);
        } else {
          const position: any = imageJson.frames[imageName].frame;
          const options: any = { img: image };
          $.extend(options, position);
          const img = new Image();
          if (
            spriteContainer[imageName] == null ||
            spriteContainer[imageName] === undefined
          ) {
            const canvas = document.createElement('canvas');
            canvas.width = options.w;
            canvas.height = options.h;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(
              options.img,
              options.x,
              options.y,
              options.w,
              options.h,
              0,
              0,
              options.w,
              options.h
            );
            spriteContainer[imageName] = canvas.toDataURL('image/webp');
          }
          resolve(spriteContainer[imageName]);
        }
      }
    });
  }
}
